/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MonatsauswertungSpalteDto } from '../../models/monatsauswertung-spalte-dto';

export interface GetAllMonatsauswertungSpalten$Plain$Params {
}

export function getAllMonatsauswertungSpalten$Plain(http: HttpClient, rootUrl: string, params?: GetAllMonatsauswertungSpalten$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MonatsauswertungSpalteDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllMonatsauswertungSpalten$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MonatsauswertungSpalteDto>>;
    })
  );
}

getAllMonatsauswertungSpalten$Plain.PATH = '/v1/monatsauswertungen/layouts/spalten';
